// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-button{width:142px;height:37px;background:none;border:1px solid #222533;box-sizing:border-box;border-radius:5px}.filter-button>span{font-family:Lato;font-style:normal;font-weight:bold;font-size:13px;line-height:16px;color:#222533;margin-left:10px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
